import BreadcrumbLink from 'features/shared/components/breadcrumbs/BreadcrumbLink';
import ModuleContent from 'features/shared/layout/content/ModuleContent';
import Header from 'features/shared/layout/header/Header';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import NavTab from 'features/shared/components/navs/NavTab';
import TabsNavigation from 'features/shared/components/navs/TabsNavigation';
import { getContractualAccountDetailRoute } from 'features/shared/helpers/routeHelper';

interface Props {
  contractualAccountId: string;
  children: ReactNode;
  links: BreadcrumbLink[];
  showLinkToDetail?: boolean;
  isFueling?: boolean;
}

const ContractualAccountDetailLayoutPage = ({ contractualAccountId, children, links, showLinkToDetail = true, isFueling }: Props) => {
  // translation
  const { t } = useTranslation("shared\\moduleNames");
  const tLabels = useTranslation("contractualAccounts\\contractualAccounts").t;

  // helpers
  const getLinks = (): BreadcrumbLink[] => {
    let result: BreadcrumbLink[] = [{ text: t("contractualAccounts.title"), to: "/contractual-accounts" }];  

    if (showLinkToDetail) {
      result.push({ text: t("contractualAccountDetail.title"), to: `detail` });
    }

    result.push(...links);

    return result;
  }

  const getRoute = (routeSuffix: string) => { 
    return getContractualAccountDetailRoute(
      contractualAccountId,
      routeSuffix,
      isFueling
    )
  }

  // render
  return (
    <>
      <Header
        title={tLabels("contractualAccountDetailLayoutPage.pageTitle")}
        includeBreadcrumbs
        titleAsBreadcrumbLink={false}
        links={getLinks()}
      />
      <ModuleContent>
        <TabsNavigation asModuleTabs>
        <NavTab to={getRoute("contracts")}>
            {tLabels("contractualAccountDetailLayoutPage.contracts")}
          </NavTab>
          <NavTab to={getRoute("invoices")}>
            {tLabels("contractualAccountDetailLayoutPage.invoices")}
          </NavTab>
          <NavTab to={getRoute("payments")}>
            {tLabels("contractualAccountDetailLayoutPage.payments")}
          </NavTab>
          <NavTab to={getRoute(`detail`)}>
            <span className="d-sm-none"> {tLabels("contractualAccountDetailLayoutPage.detail.mobile")}</span> 
            <span className="d-none d-sm-inline"> {tLabels("contractualAccountDetailLayoutPage.detail.desktop")}</span> 
          </NavTab>
        </TabsNavigation>
        {children}
      </ModuleContent>
    </>
  )
}

export default ContractualAccountDetailLayoutPage;
